// 设置千分位
export default function(value) {
    return Number(value).toLocaleString()
}


// WEBPACK FOOTER //
// ./src/filter/toLocaleString.js